import React from 'react';
import { useTranslation } from 'react-i18next';
import { GraphCard, GraphSeries } from '../../../../ui/GraphCard';
import { getColorForIndex } from '../../../../../utils/chartColors';
import { HydratedLineChartBlock } from '../../../../../services/admin/cloudAgentTypes';
import { BlockSourceNote } from './BlockSourceNote';
import { BlockNote } from './BlockNote';

/** lineChart → GraphCard. */
export const LineChartBlock: React.FC<{ block: HydratedLineChartBlock }> = ({ block }) => {
  const { t } = useTranslation();
  const series: GraphSeries[] = block.data.series.map((s, i) => ({
    label: s.label,
    values: s.values,
    color: s.color || getColorForIndex(i),
  }));
  return (
    <div>
      {/* Own horizontal scroller: a many-point series must never widen the page on mobile. The
          caption and source note sit OUTSIDE it, so they don't scroll away with the chart. */}
      <div className="overflow-x-auto">
        <GraphCard
          title={block.title ?? t('cloudAgent.blockTitles.lineChart')}
          xLabels={block.data.xLabels}
          series={series}
        />
      </div>
      <BlockNote note={block.data.note} />
      <BlockSourceNote source={block.source} />
    </div>
  );
};
